import React, { useEffect, useState } from 'react';
import { constructionRequest } from '../utils/constructionApi';

export const IMAGE_PLACEHOLDER = 'data:image/svg+xml,' + encodeURIComponent(
  '<svg xmlns="http://www.w3.org/2000/svg" width="140" height="100" viewBox="0 0 140 100"><rect width="140" height="100" fill="#f3f4f6"/><text x="70" y="54" text-anchor="middle" fill="#6b7280" font-size="12">Image unavailable</text></svg>'
);

export default function AuthenticatedImage({ src, alt, ...props }) {
  const [loaded, setLoaded] = useState(null);
  useEffect(() => {
    const controller = new AbortController();
    let objectUrl;
    setLoaded(null);
    if (src) {
      constructionRequest(src, { signal: controller.signal })
        .then((response) => response.blob())
        .then((blob) => {
          if (controller.signal.aborted) return;
          objectUrl = URL.createObjectURL(blob);
          setLoaded({ src, objectUrl });
        })
        .catch(() => { /* Keep a local placeholder; never retry a failed image. */ });
    }
    return () => {
      controller.abort();
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [src]);

  return <img {...props} alt={alt}
    src={loaded?.src === src ? loaded.objectUrl : IMAGE_PLACEHOLDER}
    onError={() => setLoaded(null)} />;
}
